import React from 'react';

export default function NotFound() {
  return (
    <div className='notFound'>
      <h1>Oups, cette page n'existe pas !</h1>
    </div>
  );
}
